<template>
<div class="organ-detail">
  <div class="user-detail">
    <div class="companyIcon">
      <svg-icon slot="corp" icon-class="corp"/>
    </div>
    <div class="companyName">{{organDetail.companyName}}</div>
    <div class="desc">
      <div class="title">{{$t('addressBook.CompanyProfile')}}</div>
      <div class="content" v-if="organDetail.companyDesc">{{organDetail.companyDesc}}</div>
      <div class="empty" v-else>{{$t('home.CompanyNotIntroduce')}}</div>
    </div>
    <div class="address">
      <div class="title">{{$t('addressBook.CompanyAddress')}}</div>
      <div class="content" v-if="organDetail.companyAddr">{{organDetail.companyAddr}}</div>
      <div class="empty" v-else>{{$t('home.CompanyNotAddress')}}</div>
    </div>
  </div>
  <svg-icon icon-class="quarter-round" class-name="quarter-round" />
</div>
</template>

<script>

export default {
  name: 'OrganDetailCompany',
  props: ['organDetail'],
}
</script>

<style scoped lang="less">
.organ-detail {
  position: relative;
  background: #F7F8FA;
  box-shadow: 5px 0 10px 0 rgba(151, 171, 199, 0.06);
}
.user-detail {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate3d(-50%,-50%,0);
  width: 480px;
  height: 560px;
  background-color: #fff;
  box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
  border-radius: 16px;
  border: 1px solid #EDEFF2;
  padding: 80px 77px 0;
  .companyIcon {
    text-align: center;
    line-height: 88px;
    border-radius: 16px;
    font-size: 88px;
  }
  .companyName{
    margin: 48px 0;
    font-size:28px;
    text-align: center;
  }
  .address, .desc{
    font-size: 16px;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 16px;
    .title{
      color: #333333;
      margin-right: 32px;
    }
    .content {
      flex: 1;
    }
    .empty{
      color:#999B9F;
    }
  }
}
.quarter-round {
  width: 549px;
  height: 579px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
